import { get, post, put, del, toastErrorHandle } from './http-methods'

export const sortEntity = (a, b) => a.name.localeCompare(b.name, { sensitivity: 'accent' });

export default {
  getList() {
    return get('/users').then(resp => resp.json.data.sort(sortEntity));
  },
  create(payload) {
    return post('/users', payload).then(resp => resp.status === 201 ? resp.json.data : toastErrorHandle(resp));
  },
  update(id, payload) {
    return put(`/users/${id}`, payload).then(resp => resp.status === 204 ? null : toastErrorHandle(resp));
  },
  del(id) {
    return del(`/users/${id}`).then(resp => resp.status === 204 ? null : toastErrorHandle(resp));
  }
}
